export const RocketSvg = () => {
    return (
        <svg
            width="81"
            height="82"
            viewBox="0 0 81 82"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.662109 53.0521L12.6817 41.0325L0.662109 29.0129L10.6911 18.984H34.7492L52.7975 0.935627H80.8559V28.994L62.8075 47.0423V71.1004L52.7786 81.1294L40.759 69.1098L28.7394 81.1294L17.7246 70.1146L30.9196 56.9196L24.9098 50.9098L11.7148 64.1048L0.681065 53.071L0.662109 53.0521ZM66.8077 24.9938C64.0398 27.7617 59.5467 27.7617 56.7788 24.9938C54.0109 22.2258 54.0109 17.7327 56.7788 14.9648C59.5467 12.1969 64.0398 12.1969 66.8077 14.9648C69.5757 17.7327 69.5757 22.2258 66.8077 24.9938Z"
                fill="#1868DB"
            />
        </svg>
    );
};
